import { Component, OnInit, Input } from '@angular/core';

import { camps } from '../../../../../models/models.generated';
import { campsenum } from '../../../../../models/enums.generated';

@Component({
    selector: 'app-acquired-sessions-summary',
    templateUrl: './acquired-sessions-summary.component.html',
    styleUrls: ['./acquired-sessions-summary.component.scss'],
    standalone: false
})
export class AcquiredSessionsSummaryComponent implements OnInit {

    @Input()
    public purchase: camps.CampPurchaseDetails;

    constructor() { }

    ngOnInit() {
    }


    getCouponDescription(details: camps.AppliedCouponInfo) {
        if (details.type == campsenum.CouponType.Amount) {
            return "$" + details.value;
        }

        if (details.type == campsenum.CouponType.FreeWeeks) {
            return "-" + details.value + " weeks";
        }

        if (details.type == campsenum.CouponType.FreeDays) {
            return "-" + details.value + " days";
        }

        if (details.type == campsenum.CouponType.Percentage) {
            return  details.value + "%, " + "max $" + details.maxDiscountAmount;
        }

        return "";
    }
}
